import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ImportPreview, ImportResult } from '../models/test-case-import.model';
import { filenameFromContentDisposition } from '../shared/file-download';

export interface TemplateDownload {
  blob: Blob;
  filename: string;
}

const TEMPLATE_FORMAT = 'xlsx';
const DEFAULT_TEMPLATE_FILENAME = 'testfaelle-import-vorlage.xlsx';

@Injectable({ providedIn: 'root' })
export class TestCaseImportService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/projects`;

  preview(projectId: string, file: File): Observable<ImportPreview> {
    return this.http.post<ImportPreview>(`${this.importUrl(projectId)}/preview`, this.toFormData(file));
  }

  commit(projectId: string, file: File): Observable<ImportResult> {
    return this.http.post<ImportResult>(`${this.importUrl(projectId)}/commit`, this.toFormData(file));
  }

  downloadTemplate(projectId: string): Observable<TemplateDownload> {
    const params = new HttpParams().set('format', TEMPLATE_FORMAT);
    return this.http
      .get(`${this.importUrl(projectId)}/template`, { params, responseType: 'blob', observe: 'response' })
      .pipe(
        map((response) => ({
          blob: response.body ?? new Blob(),
          filename: filenameFromContentDisposition(
            response.headers.get('Content-Disposition'),
            DEFAULT_TEMPLATE_FILENAME,
          ),
        })),
      );
  }

  private importUrl(projectId: string): string {
    return `${this.baseUrl}/${projectId}/test-cases/import`;
  }

  private toFormData(file: File): FormData {
    const formData = new FormData();
    formData.append('file', file);
    return formData;
  }
}
